import { ProductType } from "@obg/core.config";

import { AUTH_ROUTE } from "./auth/auth.const";
import { CUSTOMER_MANAGEMENT_ROUTE } from "./customer-management/customer-management.const";
import { RESPONSIBLE_GAMING_ROUTE } from "./responsible-gaming/responsible-gaming.const";

export const CORE_ROUTE = {
	home: "home",
	auth: AUTH_ROUTE,
	lobbies: {
		sportsbook: ProductType.Sportsbook,
		casino: ProductType.Casino,
		livecasino: ProductType.LiveCasino,
		horseRacing: ProductType.HorseRacing,
		virtualSports: ProductType.VirtualSports,
		poker: ProductType.Poker,
		turkishPoker: ProductType.TurkishPoker,
		slots: ProductType.Slots,
	},
	verification: {
		root: "verification",
		phoneVerification: "verification.phone-verification",
		kycMethodSelection: "kyc-method-selection",
	},
	payment: {
		deposit: "deposit",
		// deposit2 is used for mobile quick deposit, it should be removed once mobile is migrated to deposit dialog
		deposit2: "deposit2",
		withdraw: "withdraw",
	},
	withdrawalStatus: "withdraw-status",
	quickDeposit: "quick-deposit",
	promotions: {
		root: "promotions",
		tournaments: "promotions.tournaments",
		leaderboards: "promotions.leaderboards",
		groups: "promotions.groups",
		million: "promotions.million",
		promotion: "promotions.promotion",
		myOffersLobby: "promotions.my-offers",
		myOffersBonus: "promotions.my-offers-bonus",
		myOffersOffer: "promotions.my-offers-offer",
	},
	registration: {
		register: "register",
		registerGeneric: "register-generic",
		registerSga: "register-sga",
		quickRegister: "quick-register",
		manualRegister: "manual-register",
		SPIDRegister: "spid-register",
		SPIDAuthorization: "authorization",
		SPIDConfirmation: "confirmation",
		SPIDError: "error",
		quickRegisterError: "quick-register-error",
		registerSuccess: "registration-success",
		activateAccount: "activate-account",
		activateAccountWithEmail: "activate-account-with-emails",
	},
	termsAndConditions: "terms-and-conditions",
	oms: {
		messages: "messages",
		active: "messages.active",
		expired: "messages.expired",
	},
	cookieSettings: "cookie-settings",
	responsibleGaming: RESPONSIBLE_GAMING_ROUTE,
	customerManagement: CUSTOMER_MANAGEMENT_ROUTE,
	balance: "balance",
	marketingSettings: {
		root: "marketing-settings",
		marketingConsents: "marketing-settings.marketing-consents",
		cookieConsents: "marketing-settings.cookie-consents",
	},
	preferencesSettings: {
		root: "preferences-settings",
		gamePlay: "preferences-settings.game-play",
	},
	transactionHistory: {
		all: "transaction-history",
		payments: "transaction-history.payments",
		activity: "transaction-history.activity",
		currentSession: "transaction-history.current-session",
		details: "transaction-history.details",
	},
	gameRoundHistory: "game-round-history",
	missions: {
		root: "missions",
		upcoming: "missions.upcoming",
		active: "missions.active",
		ended: "missions.ended",
	},
	loyalty: {
		root: "loyalty",
		status: "loyalty.status",
		history: "loyalty.history",
		howItWorks: "loyalty.how-it-works",
		faq: "loyalty.faq",
	},
	reward: {
		welcomeBonus: "welcome-bonus",
		rewards: "rewards",
		claimable: "rewards.claimable",
		active: "rewards.active",
		ended: "rewards.ended",
		rewardDetail: "rewards.detail",
		depositBonus: "rewards.deposit",
	},
	casino: {
		gameSearch: "casino.search",
	},
	launchGame: "launch-game",
	commonPokerLogin: "common.poker-inclient.login",
	pokerLogin: "poker-inclient.login",
	pokerDepositWithdraw: "poker-inclient.deposit-withdraw",
	pokerCasinoGallery: "poker-inclient.casino-gallery",
	iosNativeBlock: "ios-native-block",
	notFound: "not-found",
	internalError: "internal-error",
	error: "error",
	sportBlog: "sport-blog",
};
